import { apiClient } from "./client";

const BedActivate = (id, isActive) => {
  return apiClient.put('/Bed/BedActivate', null, {
    params: {
      'Id': id,
      'isActive': isActive
    }
  }
  )
}

const bedApi = {
  BedActivate
}

export default bedApi